(($) => {$(() => {

  $('#newsletterSuccessSubmit').click(function() {
    $('.newsletter-submit-form').css('opacity', '0.5');
  	let subscriber = '';
  	try {
      subscriber = document.cookie.split(';').filter((item) => item.indexOf('nl_modal_email') >= 0)[0].split('=')[1];
    } catch(err) {}
    var _formData = {};
  	_formData['segment'] = $(".newsletter-submit-form input:checkbox:checked").map(function(){return $(this).data('val')}).get();
  	_formData['email'] = subscriber;
    console.log(_formData);
    let fetchOptions = {
      method: 'POST',
      body: JSON.stringify(_formData),
    };
    appRequest(`/cm/subscriber/updateSegments`, fetchOptions)
    .then(response => response.json())
    .then(json => {
      $('.newsletter-submit-form').hide(300);
      $('.newsletter-segment-success').show(300);
    })
    .catch(error => {
      console.log(error);
    });
    return false;
  });
  
  
})})(jQuery);